import React from 'react'
import { ISubheaderProps, Subheader } from './components/Subheader'
import { useAppDispatch, useAppSelector } from '../../app/hooks'
import { RootState } from '../../app/store'
import { getPageFromLocation, pages } from '../../constants/pages'
import { getCognitiveExerciseStatus } from './exerciseHelper'
import { ExerciseKey, exerciseTypeMap } from '../../constants/exercises'
import { push } from 'connected-react-router'

const  SubheaderConnect = () => {
  const dispatch = useAppDispatch()
  const { location } = useAppSelector((state: RootState) => state.router)
  const state = useAppSelector((state: RootState) => state)
  const page = getPageFromLocation(location)
  const cognitiveExerciseStatus = getCognitiveExerciseStatus(state, page)
  const whyThisMattersSlug = page && page.hasWhyThisMatters ? exerciseTypeMap[page.key as ExerciseKey] : undefined
  const isStartingExercise = cognitiveExerciseStatus === 'start'
  const handleWhyThisMatters = (slug: string) => {
    dispatch(push(`${pages.whyThisMatters.route}#${slug}`))
  }
  const subheaderProps: ISubheaderProps = {
    title: page?.title ?? '',
    pageKey: page?.key ?? '',
    whyThisMattersSlug,
    isStartingExercise,
    gotoWhyThisMatters: handleWhyThisMatters,
  }
  return (
    <Subheader { ...subheaderProps } />
  )
}

export default SubheaderConnect